import { maskDate, toIsoDate } from './masks.js';

const TEXT_MAX_LENGTH = 500;
const LONG_TEXT_MAX_LENGTH = 4000;
const NUMBER_MAX_LENGTH = 10;

export function getFormCustomFields(config) {
  return (config.Behaviour?.CustomFields || []).filter(field => field.Label);
}

export function maskCustomFieldValue(field, value) {
  if (field.Type === 'Date') return maskDate(value);
  if (field.Type === 'Number') return String(value).replace(/[^\d-]/g, '').replace(/(?!^)-/g, '').slice(0, NUMBER_MAX_LENGTH);
  return value;
}

export function customFieldMaxLength(field) {
  if (field.Type === 'Text') return TEXT_MAX_LENGTH;
  if (field.Type === 'LongText') return LONG_TEXT_MAX_LENGTH;
  if (field.Type === 'Date') return 10;
  if (field.Type === 'Number') return NUMBER_MAX_LENGTH;
  return undefined;
}

export function validateCustomField(field, rawValue) {
  const value = String(rawValue || '').trim();
  if (!value) return field.Required ? `${field.Label} é obrigatório` : '';
  if (field.Type === 'Date' && !toIsoDate(value)) return `${field.Label}: data inválida`;
  if (field.Type === 'Number' && !/^-?\d{1,9}$/.test(value)) return `${field.Label}: número inválido`;
  return '';
}

export function isCustomFieldFilled(rawValue) {
  return String(rawValue || '').trim().length > 0;
}

export function buildCustomFieldsPayload(config, values, target) {
  const payload = {};

  for (const field of getFormCustomFields(config)) {
    if (field.Target !== target) continue;

    const value = String(values?.[field.Key] || '').trim();
    if (!value) continue;

    payload[field.Key] = field.Type === 'Date' ? toIsoDate(value) : value;
  }

  return payload;
}
